import { BaseCTA, CardCTAProps } from '@src/components/Cards/CardActions'
import { seeSources } from '@src/state/document/actions'
import { decodeHtml } from '@src/utils/decode'
import * as React from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import styled from 'styled-components'
import { CardBodyProps } from './CardBody'
import { BodyContainer } from './styles'

const PlagiarismMessage = styled.div`
  color: ${({ theme }) => theme.colors.greyMedium};
  font-size: ${({ theme }) => theme.font.text.size.sm};
`

const ErrorText = styled.span`
  padding-right: ${({ theme }) => theme.spacing.md};
  font-size: ${({ theme }) => theme.font.text.size.sm};
  margin-top: ${({ theme }) => theme.spacing.sm};
`

const PlagiarismBody = styled.div`
  display: flex;
  flex-direction: column;
`

export const PlagiarismCardBody: React.FunctionComponent<CardBodyProps> = ({
  errorText,
}) => (
  <BodyContainer>
    <PlagiarismBody>
      <PlagiarismMessage>We found this text in our plagiarism check</PlagiarismMessage>
      <ErrorText>{decodeHtml(errorText)}</ErrorText>
    </PlagiarismBody>
  </BodyContainer>
)

interface PlagiarismCardCTAProps extends CardCTAProps {
  handleAccept: () => void
  showSourcesModal: () => void
  'aria-labelledby': string
  id: string
}

interface DispatchProps {
  showSourcesModal: (metadataId: string) => void
}

type Props = PlagiarismCardCTAProps & DispatchProps
const PlagiarismCardCTA: React.FunctionComponent<Props> = ({
  handleIgnore,
  acceptText,
  ignoreText,
  showSourcesModal,
  id,
  'aria-labelledby': ariaLabelledBy,
}) => {
  const seeSourcesModal = () => showSourcesModal(id)
  return (
    <BaseCTA
      acceptText={acceptText}
      ignoreText={ignoreText}
      handleAccept={seeSourcesModal}
      handleIgnore={handleIgnore}
      aria-labelledby={ariaLabelledBy}
      id={id}
    />
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  showSourcesModal: (metadataId: string) => dispatch(seeSources({ metadataId })),
})

export const ConnectedPlagiarismCardCTA = connect<PlagiarismCardCTAProps, DispatchProps>(
  null,
  mapDispatchToProps
)(PlagiarismCardCTA)



// WEBPACK FOOTER //
// ./src/components/Cards/PlagiarismCard.tsx